import { useQuery } from '@apollo/client';

import availableIdentifiersQuery from './availableAssetIdentifiers.graphql';

export default function useAvailableAssetIdentifiers() {
  return useQuery(availableIdentifiersQuery);
}
